import React from 'react';
{/*Creating Theme Context...*/}
const ThemeContext = React.createContext();
export default ThemeContext;